module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "tree-button",
    class: [
      _vm.type,
      _vm.inline ? 'inline' : 'block',
      _vm.round ? 'round' : '',
      _vm.plain ? 'plain' : ''
    ],
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "tree-button-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-06712b3d!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/source/button.vue
// module id = 332
// module chunks = 0